
import React from 'react'
import Link from 'ui/Link'
import Space from 'ui/Space'
import css from './ForgotDone.module.css'

const ForgotDone = () => {
  return (
    <div className={css.main}>
      <h2>Check your email</h2>
      <Space value={15} />
      <p>We just sent you an email containing a temporary link that will allow you to reset your password. Please check your spam folder if the email doesn’t appear within a few minutes.</p>
      <Space value={15} />
      <p>If there are any issues <Link href='mailto:friends@segment.com' rel='external' target='_blank'>email us</Link>, and we’ll help fix it!</p>
    </div>
  )
}

export default ForgotDone



// WEBPACK FOOTER //
// ./components/ForgotDone.js